export default {"src":"https://fishbrain.com/_next/static/media/channelCatfish.3dc9d2be.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};